import { Outlet } from "@tanstack/react-router";
import { Route } from "@/routes/(auth)/_headed/funds/basket.$basket_id";
import { useFundBasket } from "creso-core/hooks";
import { FundBasketSidebar } from "@funds/components/baskets/fund-basket-sidebar";
import { Page } from "@core/components/layout/page";
import {
  PageNavbar,
  PageNavbarItem,
} from "@core/components/layout/page-navbar";

export function FundBasketLayout() {
  const { basket: defaultBasketData } = Route.useLoaderData();

  const { data: basket } = useFundBasket(defaultBasketData.id, {
    initialData: defaultBasketData,
  });

  if (!basket) return null;

  return (
    <Page>
      <Page.Sidebar className="gap-8">
        <FundBasketSidebar basket={basket} />
      </Page.Sidebar>
      <Page.Content>
        <PageNavbar>
          <PageNavbarItem
            to="/funds/basket/$basket_id"
            params={{ basket_id: basket.id }}
            activeOptions={{ exact: true }}
          >
            Overview
          </PageNavbarItem>
          <PageNavbarItem
            to="/funds/basket/$basket_id/linked-sip"
            params={{ basket_id: basket.id }}
          >
            Linked SIPs
          </PageNavbarItem>
        </PageNavbar>
        <div className="flex flex-col flex-1 gap-8 relative bg-background rounded-lg p-5">
          <Outlet />
        </div>
      </Page.Content>
    </Page>
  );
}
